import type { TBgColor } from '@/components/_promo/templates/BanksBenefitsTemplate/styled';
import { ImageComponent } from '@/components/Image';
import { useMedia } from '@/hooks';
import { brandSizeMap, getBrandKey, paymentBrands } from './helpers';
import { ScBanksLogosListWrapper } from './styled';

const defaultImgSrc = (src: string) => `/lp/banks-benefits/${src}.webp`;

type TBrandSizeMap = Record<string, { width: number; height: number }>;

interface IBanksLogosListProps {
  bgColor?: TBgColor;
  brands?: string[];
  imgSrc?: (name: string) => string;
  brandSizes?: TBrandSizeMap;
  useSizesOnMobile?: boolean;
}

export const BanksLogosList = ({
  bgColor,
  brands = paymentBrands,
  imgSrc = defaultImgSrc,
  brandSizes,
  useSizesOnMobile = false,
}: IBanksLogosListProps) => {
  const { isMobile } = useMedia();
  const sizeMap: TBrandSizeMap = brandSizes ?? brandSizeMap;
  const getSize = (name: string) => sizeMap[name] ?? sizeMap[getBrandKey(name)];
  const useFill = isMobile && !useSizesOnMobile;

  return (
    <ScBanksLogosListWrapper
      $bgColor={bgColor}
      $useSizesOnMobile={useSizesOnMobile}
    >
      {brands.map((name) => (
        <div className="bank" key={name}>
          <ImageComponent
            alt={name}
            className="bank-img"
            fill={useFill}
            src={imgSrc(name)}
            {...(!useFill && {
              width: getSize(name).width,
              height: getSize(name).height,
            })}
          />
        </div>
      ))}
    </ScBanksLogosListWrapper>
  );
};
